import { getBackendUrl } from '../utils/apiUrl';
import { getAnonymousUserId, getSessionId } from '../utils/anonymousUser';

const BACKEND_URL = getBackendUrl();

/**
 * Referrers can contain invite codes, OAuth details, or lead tokens. The
 * visitor map only needs the referring site, so never send its path/query.
 */
export function safeReferrer(rawReferrer) {
  if (!rawReferrer) return '';
  try {
    const parsed = new URL(rawReferrer, window.location.origin);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
    return parsed.origin;
  } catch {
    return '';
  }
}

/**
 * Best-effort visitor-map beacon for the registration surfaces. This is
 * deliberately separate from GA/Meta page views and never includes URL query
 * parameters, hashes, or form values. The one exception is an invite code,
 * sent as its own field and only when the caller extracted one.
 */
export function recordRegistrationPageView(pathname, { referralCode } = {}) {
  try {
    const body = JSON.stringify({
      anonymousId: getAnonymousUserId(),
      sessionId: getSessionId(),
      url: pathname,
      referrer: safeReferrer(document.referrer),
      // A colleague's invite code, so the admin map can name who invited this
      // visitor. The code is already shared by hand; it is never a login.
      ...(referralCode ? { referralCode } : {}),
    });

    fetch(`${BACKEND_URL}/api/visitor-events/registration-page-view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {
      // Visitor analytics must never interfere with registration.
    });
  } catch {
    // Storage and fetch can both be unavailable in locked-down browsers.
  }
}
